import { newAxiosIns } from '@/libs/axios'

const apiSetStatusOrderAi = (orderId, status) => newAxiosIns.patch(`komship/api/v1/orders/komchat/${orderId}`, { status })

const apiExportKomship = ids => newAxiosIns.post('komship/api/v1/orders/komchat/export/komship', {
  checked_all: false,
  id: ids,
})

export default {
  apiSetStatusOrderAi,
  apiExportKomship,
}
